module.exports = __webpack_public_path__ + "img/emoji_kunjuan.3917991d.png";